import apiClient from 'services/axios'
import { notification } from 'antd'

export const createTicket = async (ticketData) => {
  try {
    return await apiClient.post('/ticket/create-ticket', ticketData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getAllTickets = async ({ skip, limit, status, priority, assignedTo }) => {
  try {
    return await apiClient.get('/ticket/get-tickets', {
      params: { skip, limit, status, priority, assignedTo },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getTicketsByUserId = (userId, params) => {
  return apiClient.get(`/ticket/user/${userId}`, { params })
}

export const getActiveTicketsByUserId = (userId) => {
  return apiClient.get(`/ticket/active-ticket/${userId}`)
}

// ticket attachment

export const getTicketAttachmentById = async (ticketId) => {
  try {
    const response = await apiClient.get(`/ticket/all-attachments/${ticketId}`)
    return response.data
  } catch (error) {
    notification.error({
      message: 'Error',
      description: error?.response?.data?.message || 'Failed to fetch attachment.',
    })
    return null
  }
}

export const assignTicketToAgentApi = (ticketId, assignedTo) => {
  return apiClient.put(`/ticket/${ticketId}/assign`, { assigned_to: assignedTo })
}

// get ticket by agent
export const getTicketsByAgent = (agentId, params) => {
  return apiClient.get(`/ticket/agent/${agentId}`, { params })
}

export const getTicketAttachment = async (attachmentid) => {
  try {
    const response = await apiClient.get(`/ticket/attachments/${attachmentid}`, {
      responseType: 'blob',
    })
    // Important for file content

    return response.data // Blob data, you can create URL or download file
  } catch (error) {
    notification.error({
      message: 'Error',
      description: error?.response?.data?.message || 'Failed to fetch attachment.',
    })
    return null
  }
}

export const getAllTechSupport = async () => {
  try {
    return await apiClient.get('/ticket/tech-support-users')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const editTicketById = async (ticketId, ticketData) => {
  try {
    return await apiClient.put(`/ticket/update-ticket-status/${ticketId}`, ticketData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const deleteTicketById = async (ticketId) => {
  try {
    return await apiClient.delete(`/ticket/delete-ticket/${ticketId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const uploadTicketAttachment = async (formData, ticketId) => {
  return apiClient.post(`/ticket/${ticketId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// comments

export const createCommentsData = async (ticketid, message) => {
  try {
    return await apiClient.post('/ticket/create-comment', ticketid, message)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

// Fetch comments for a ticket
export const getCommentsByTicketId = async (ticketId) => {
  try {
    return await apiClient.get(`/ticket/get-comments/${ticketId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
